import { ModuleFE_InstallationFlowsheetConfiguration } from './ModuleFE_InstallationFlowsheetConfiguration.js';
export const ModulePackFE_InstallationFlowsheetConfiguration = [ModuleFE_InstallationFlowsheetConfiguration];
//# sourceMappingURL=module-pack.js.map